/* eslint-disable no-nested-ternary */
import { any, array, bool, func, object, string } from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import OnboardingSection from "./OnboardingSection";
import * as style from "./styles.module.scss";

const Container = ({ obj, submit }) => {
  // sorround component with section div
  const {
    title,
    subtext,
    formsListWithStatus,
    submitted,
    readingListWithStatus,
    currentlyReading,
    setCurrentlyReading,
    markDocumentRead,
    isLoading,
    customComp,
    lastInColumn,
    hasSignatureUpload = false,
    fileUpload = false,
    fileUploadCond = false,
    fileUploadDesc = "",
    fileUploadTitle = "",
    fileUploadKey = "",
    imageFileKey = "",
  } = obj;

  if (customComp) {
    return (
      <div
        style={{ marginTop: lastInColumn ? "1rem" : 0 }}
        className={`${style.readingList__wrapper} section-body mb-1 pt-1 bg-white`}
      >
        {title ? <h5 className="px-1">{title}</h5> : null}
        {typeof subtext === "object" ? (
          subtext.map((row) => (
            <p key={row} className="px-1" style={{ width: "90%" }}>
              {row}
            </p>
          ))
        ) : subtext ? (
          <p className="p-1" style={{ width: "90%" }}>
            {subtext}
          </p>
        ) : null}
        {customComp}
      </div>
    );
  }

  return (
    <div style={{ marginTop: lastInColumn ? "1rem" : 0 }}>
      <OnboardingSection
        title={title}
        subtext={
          subtext ||
          "Please complete all of the below forms. Once you have completed all forms, please click on the Submit button to finish your onboarding process. Once you have submitted your forms you will be unable to edit them. If you have any queries about the forms, please speak to your HRGO Consultant."
        }
        formsListWithStatus={formsListWithStatus || []}
        readingListWithStatus={readingListWithStatus || []}
        submitted={submitted}
        submit={submit}
        currentlyReading={currentlyReading}
        setCurrentlyReading={setCurrentlyReading}
        markDocumentRead={markDocumentRead}
        isLoading={isLoading}
        hasSignatureUpload={hasSignatureUpload}
        fileUploadDesc={fileUploadDesc}
        fileUploadCond={fileUploadCond}
        fileUploadTitle={fileUploadTitle}
        fileUploadKey={fileUploadKey}
        fileUpload={fileUpload}
        imageFileKey={imageFileKey}
      />
    </div>
  );
};
/**
 * A component aimed at reducing time spent adding boiler plate code when
 * creating a clients onboarding section within candidate account.
 * @param {String} title
 * @returns JSX
 */
const OnboardingCreator = ({
  title = "",
  leftColumnComponents = [],
  rightColumnComponents = [],
  leftSubmit,
  hasDBS = false,
  dbsURL = "",
  criminalConviction,
}) => {
  const LeftSection = () =>
    leftColumnComponents.map((obj) => (
      <Container
        key={obj.title}
        obj={obj}
        submit={leftSubmit}
        subtext={obj.subtext}
        customComp={obj.customComp}
      />
    )); // map all the left side components together

  const RightSection = () =>
    rightColumnComponents.map((obj) => {
      return (
        <Container
          key={obj.title}
          obj={obj}
          submit={leftSubmit}
          subtext={obj.subtext}
          customComp={obj.customComp}
        />
      );
    }); // map all the right side components together

  return (
    <div className="container text-bluishGray pb-2">
      <header className="row">
        <div className="col-12">
          <h2 className="section-header pt-2">{title}</h2>
        </div>
      </header>
      <div className={`${style.sectionContainer}`}>
        <div className={`${style.column1}`}>
          <LeftSection />
        </div>
        {rightColumnComponents ? (
          <div className={`${style.column2}`}>
            <RightSection />
            {criminalConviction ? (
              <div
                className={`${style.readingList__wrapper} section-body pt-1 mt-1 bg-white`}
              >
                {criminalConviction}
              </div>
            ) : null}
            {hasDBS ? (
              <div
                className={`${style.readingList__wrapper} section-body pt-1 bg-white`}
              >
                <h5 className="px-1">Basic DBS Information</h5>
                <p className="px-1">
                  A DBS check is required for the job role you applied for.
                  Please click on the link below and complete the form to enable
                  HRGO to complete a DBS check.
                </p>
                <div
                  style={{
                    with: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: "1rem",
                  }}
                >
                  <a
                    href={dbsURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary ml-sm-1 mt-hf mt-sm-0 styles__onboarding__btn___3so8L"
                  >
                    DBS Form
                  </a>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}

        {/* ) : null} */}
      </div>
      <div className="d-flex justify-content-end mt-2" style={{ width: "96%" }}>
        <Link to="/profile" className="btn btn-primary px-3">
          Back to My Account
        </Link>
      </div>
    </div>
  );
};

OnboardingCreator.propTypes = {
  title: string,
  leftColumnComponents: array,
  rightColumnComponents: array,
  leftSubmit: any,
  hasDBS: bool,
  dbsURL: string,
  criminalConviction: func,
  fileUploadDesc: string,
  fileUploadTitle: string,
  fileUploadKey: string,
  fileUploadCond: bool,
  fileUpload: bool,
};

Container.propTypes = {
  obj: object,
  submit: any,
};

export default OnboardingCreator;
